var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6 0C2.68649 0 0 2.68649 0 6C0 9.31389 2.68649 12 6 12C9.31389 12 12 9.31427 12 6C12 2.68649 9.31385 0 6 0ZM6 10.875C3.30752 10.875 1.12502 8.69248 1.12502 6C1.12502 3.30752 3.30752 1.12502 6 1.12502C8.69248 1.12502 10.875 3.30752 10.875 6C10.875 8.69248 8.69248 10.875 6 10.875ZM6.00038 2.63136C5.57064 2.63136 5.24549 2.85563 5.24549 3.21787V6.54036C5.24549 6.90298 5.5706 7.12649 6.00038 7.12649C6.41963 7.12649 6.75527 6.89362 6.75527 6.54036V3.21787C6.75523 2.86423 6.41963 2.63136 6.00038 2.63136ZM6.00038 7.875C5.5875 7.875 5.25148 8.21102 5.25148 8.62423C5.25148 9.03673 5.5875 9.37275 6.00038 9.37275C6.41325 9.37275 6.74889 9.03673 6.74889 8.62423C6.74885 8.21098 6.41325 7.875 6.00038 7.875Z",
    fill: "#E2574C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1bab0d06eff436c11dcf5de7d8c6f5cc.svg";
export { ForwardRef as ReactComponent };